/**
 * This files contains the various types and ids of the local schema.
 */
export const AUTH_POPUP_TYPE = "AuthPopup";
export const AUTH_POPUP_ID = "client:root.local.authPopup";
